import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GACategoryName, GAEventNames, GAUniqueEventIds, GenderType } from "../../../helpers/Enums";
import { validate, VALIDATOR_MATCHING_VALUES, VALIDATOR_PASSWORD, VALIDATOR_REQUIRE } from "../../../helpers/Validators";
import { setSignupData } from "../../../redux/signup";
import { RootState } from "../../../redux/store";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const SelectPasswordQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 4));
    const [password, setPassword] = useState<string>("");
    const [passwordMatch, setPasswordMatch] = useState<string>("");
    const [errors, setErrors] = useState<any>({});
    const [passwordShown, setPasswordShown] = useState<boolean>(false);
    const resgiter = useSelector((state: RootState) => state.signup);



    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const validateForm = () => {

        let errors: any = {};
        if (!validate(password, [VALIDATOR_REQUIRE()])) {
            errors["password"] = "חובה להזין סיסמה";
        }
        if (!validate(password, [VALIDATOR_PASSWORD()])) {
            errors["password"] = "הסיסמה צריכה להתאים להנחיות שרשומות למעלה";
        }
        if (!validate(passwordMatch, [VALIDATOR_REQUIRE()])) {
            errors["passwordMatch"] = "חובה לחזור על הסיסמה";
        }
        if (!validate(password, [VALIDATOR_MATCHING_VALUES(passwordMatch)])) {
            errors["passwordMatch"] = "הסיסמאות לא תואמות,שננסה שוב?";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            register.password = password;
            dispatch(setSignupData(register));
            props.next();

            recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 4", "אישור סיסמה", GAUniqueEventIds.APP_SIGNUP)

        }
    };

    const enabled =
        password.length > 0 && passwordMatch.length > 0;


    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{question && question[0].question}</h2>
                    <div>{question && question[0].questionSubTitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div className="field_block">
                                {/* <label htmlFor="email">הקלידו סיסמה</label> */}
                                <input autoComplete="off" dir="ltr" name="password" type={passwordShown ? "text" : "password"} value={password} placeholder="סיסמה" onChange={e => setPassword(e.target.value)} maxLength={256} className="txt_field password w-input" />
                                <div className="form_allert" style={{ display: errors && errors["password"] ? "contents" : "block" }}>{errors["password"]}</div>
                            </div>
                            <div className="field_block">
                                <label htmlFor="passwordMatch">וידוא סיסמה</label>
                                <input autoComplete="off" dir="ltr" name="passwordMatch" type={passwordShown ? "text" : "password"} placeholder={register.genderId === GenderType.MALE ? "הקלד שוב את הסיסמה" : "הקלידי שוב את הסיסמה"} value={passwordMatch} onChange={e => setPasswordMatch(e.target.value)} maxLength={256} className="txt_field password w-input" />
                                <div className="form_allert" style={{ display: errors && errors["passwordMatch"] ? "contents" : "block" }}>{errors["passwordMatch"]}</div>
                            </div>
                            <div className="form_buttons_group check">
                                <label className="w-checkbox checkbox_field w-clearfix">
                                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox"></div>
                                    <input autoComplete="off" type="checkbox" onChange={togglePasswordVisiblity}
                                        id="checkbox" name="checkbox" data-name="Checkbox" style={{ opacity: 0, position: "absolute", zIndex: -1 }} />
                                    <span className="checkbox_label w-form-label">הראו לי את הסיסמה</span>
                                </label>
                            </div>
                            <input autoComplete="off" disabled={!enabled} type="submit" value={register.genderId === GenderType.MALE ? "בחרתי, בואו נמשיך" : "אפשר להמשיך"} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive w-button"}></input>
                        </div>

                        {/* <input autoComplete="off" disabled={!enabled} type="submit" value="המשך" data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input> */}

                    </form>
                </div>
            </div>
        </>
    )
}

export default SelectPasswordQuestion;